(function () {
  'use strict';
  var locale = String(document.documentElement.lang || '').toLowerCase();
  var language = locale.indexOf('pt') === 0 ? 'pt' : locale.indexOf('en') === 0 ? 'en' : 'es';
  if (language === 'es') return;

  var copies = {
    en: 'By subscribing, you agree to receive marketing communications. Read our <a href="/policies/privacy-policy">Privacy Policy</a>.',
    pt: 'Ao subscreveres, aceitas receber comunicações comerciais. Consulta a nossa <a href="/policies/privacy-policy">Política de Privacidade</a>.'
  };

  function apply(root) {
    (root || document).querySelectorAll('footer p').forEach(function (paragraph) {
      var text = paragraph.textContent.replace(/\s+/g, ' ').trim();
      if (text.indexOf('Al suscribirte aceptas recibir comunicaciones comerciales') === 0) {
        paragraph.innerHTML = copies[language];
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { apply(document); }, { once: true });
  else apply(document);
  document.addEventListener('shopify:section:load', function (event) { apply(event.target); });
})();
